export default "__VITE_ASSET__85697c95__"